import { render, staticRenderFns } from "./ComparisonTab.vue?vue&type=template&id=05d45f55&scoped=true&"
import script from "./ComparisonTab.vue?vue&type=script&lang=js&"
export * from "./ComparisonTab.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonTab.vue?vue&type=style&index=0&id=05d45f55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d45f55",
  null
  
)

export default component.exports